import { VENDOR_BOOKINGS_DATA, VENDOR_BOOKINGS_DATA_SUCCESS, VENDOR_BOOKINGS_DATA_ERROR, VENDOR_BOOKINGS_DATA_EMPTY } from '../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorBookings = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_BOOKINGS_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case VENDOR_BOOKINGS_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorBookings;
